import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Paper } from '@mui/material';
// import { Paper } from '@mui/material';
import { Box } from '@mui/system';
import { post } from 'api';
// import avatar6 from 'assets/images/avatar/avatar_6.webp';
import DocumentList from 'components/SS/documentList';
import Ownership from 'components/sections/account/users-permissions/Ownership';

function CustomerDeocumentsApprove() {
  const location = useLocation();

  const state = location.state.state;
  const from = location.state.from;
  const [data, setData] = useState([]);
  const fetchData = async () => {
    const response = await post('/users/list_documents', {
      customerId: state._id,
    });
    setData(response.data);
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <Paper background={1} sx={{ flex: 1, p: { xs: 3, md: 5 }, pt: { xs: 3, md: 2 } }}>
        <Ownership
          name={`${state.firstName} ${state.lastName}`}
          email={state.email || state.mobile || ''}
          state={state}
          lastLoginAt="2024-11-15 15:54"
          backto={from}
        />
      </Paper>
      <Box sx={{ overflowY: 'auto' }}>
        <DocumentList docs={data} setDocs={setData} fetch={fetchData} customerId={state._id} />
      </Box>
    </>
  );
}

export default CustomerDeocumentsApprove;
